import { ListingAppearanceSection as SharedListingAppearanceSection } from "shared/app/ListingAppearanceSection";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import addressApi from "api/landlord/address";
import { Unit } from "types/landlord/address";
import { useEditDetailsPermissions } from "shared/hooks/use-edit-details-permissions";

export const ListingAppearanceSection = ({ unit }: { unit: Unit }) => {
  const {
    Units: UnitsLabel,
    units: unitsLabel,
    property: propertyLabel
  } = useUnitsPropertiesDictionary();
  const { unitEditDeniedTooltip } = useEditDetailsPermissions();

  return (
    <SharedListingAppearanceSection
      customButtonLink={unit.custom_button_link}
      inheritedLink={unit.property.custom_button_link}
      inheritedFromLabel={propertyLabel}
      bulkApply={{
        scope: "unit",
        sourceId: unit.id,
        sourceName: unit.title,
        actionLabel: `Apply to additional ${unitsLabel}`
      }}
      showWarning={Boolean(unit.custom_button_missing_source)}
      warningText={`This ${UnitsLabel.toLowerCase()} uses a listing template with a custom button, but no custom button link is set on the ${UnitsLabel.toLowerCase()} or its ${propertyLabel}, so the button won't appear on its listing page.`}
      inputId="unit-custom-button-link"
      saveCustomButtonLink={(value) =>
        addressApi.editUnit(unit.id, {
          custom_button_link: value
        })
      }
      successToast="Unit updated successfully"
      errorToastPrefix="Failed to update unit"
      invalidateQueryKey={["unit"]}
      editDeniedTooltip={unitEditDeniedTooltip}
      pmsSync={
        unit.pms_id
          ? {
              syncWithPms: unit.pms_overrides?.custom_button_link !== false,
              pmsValue: unit.pms_values?.custom_button_link,
              saveSyncWithPms: (syncWithPms) =>
                addressApi.editUnit(unit.id, {
                  pms_overrides: { custom_button_link: syncWithPms }
                })
            }
          : undefined
      }
    />
  );
};
